import { deleteUrl, getUrl, updateUrl } from '../config'
import type { DeleteBody, GetPageBody, UpdateBody } from '../model/catalogTypes'

type DeleteData = { type: 'delete'; body: DeleteBody }
type UpdateData = { type: 'update'; body: UpdateBody }
type GetPageData = { type: 'getPage'; body: GetPageBody }

export type Request = DeleteData | UpdateData | GetPageData

// Фукнция генерирует стандартные api requests
export const GenerateRequest = (req: Request): { path: string; url: string; body?: any } | undefined => {
    const { body } = req
    switch (req.type) {
        case 'delete':
            const { id } = body as DeleteBody
            if (id) {
                let url = `${deleteUrl}/${id}`
                return { path: deleteUrl, url }
            }
            break
        case 'update':
            let { data } = body as UpdateBody
            if (data) {
                if (data?.id) {
                    let url = `${updateUrl}/${data.id}`
                    delete data.id
                    return { path: updateUrl, url, body: data }
                }
            }
            break
        case 'getPage':
            const { page, count, filter, animalType, searchValue, sort } = body as GetPageBody
            let url = `${getUrl}?`
            if (page) {
                url += `page=${page}`
            } else {
                url += `page=0`
            }
            if (count) {
                if (url.includes('page')) {
                    url += `&count=${count}`
                } else {
                    url += `count=${count}`
                }
            }
            

            if (filter) {
                const filterUrl = filter.map(items =>
                    items.items.map(({ id }) => {
                        let req = ``

                        switch (items.title) {
                            case 'Тип продукта':
                                req = `type`
                                break
                            case 'Особенности':
                                req = `animal_needs`
                                break
                            case 'Тип кормления':
                                req = `feeding_type`
                                break
                            case 'Половозрастная группа':
                                req = `animal_age`
                                break
                            case 'Тип фасовки':
                                req = `packaging_type`
                                break
                        }

                        return `&${req}=${id}`
                    })
                )

                url += filterUrl.flat().join('')
            }
            if (animalType) {
                url += animalType
            }

            if (searchValue && searchValue !== 'clear') {
                url += `&title=${searchValue}`
            }

            if(sort) {
                url += `&sort=${sort}`
            }
            return { path: getUrl, url }
    }
}
